import type { PixumEnv } from '../../types';
import { type Country } from '../i18n';
import { type LocaleIso } from '../i18n/locale';
import { PixumEnvUtils } from '../pixumEnv';

/**
 * Create a PIXUM_ENV object from country data
 *
 * @deprecated Use PixumEnvUtils.create() instead
 *
 * This function is maintained for backward compatibility only.
 * Please migrate to the PixumEnvUtils class:
 *
 * @example
 * ```typescript
 * // Old way (deprecated)
 * import { getPixumEnv } from 'utils';
 * const data = getPixumEnv(countryData, 'de-DE');
 *
 * // New way (preferred)
 * import { PixumEnvUtils } from 'utils';
 * const data = PixumEnvUtils.create(countryData, 'de-DE');
 * ```
 *
 * @param {Country} data - The country data to use for initialization
 * @param {LocaleIso} [locale] - The active locale; falls back to the first page locale when omitted
 * @returns {PixumEnv} A new PIXUM_ENV object
 */
export function getPixumEnv(data: Country, locale?: LocaleIso): PixumEnv {
  // Fall back to the first page locale to preserve the original behaviour for legacy callers
  const resolvedLocale = locale ?? (data.pages[0].locale as LocaleIso);

  return PixumEnvUtils.create(data, resolvedLocale);
}
